import React from "react";
import { IAppIco } from "../../types";
import { _fillCommonProps, _strokeCommonProps } from "../SVGFiles";

export const ClockIco: React.FC<IAppIco> = ({ asset, stroke, height, width, className }) => {
    const _classList = `${className || ""} ss-app-config-ico-${asset}`;

    return (
        <svg className={_classList} width={width || "24"} height={height || "24"} viewBox="0 0 24 24" fill="none">
            <path
                {..._fillCommonProps}
                d="M21.25 12.0005C21.25 17.1095 17.109 21.2505 12 21.2505C6.891 21.2505 2.75 17.1095 2.75 12.0005C2.75 6.8915 6.891 2.7505 12 2.7505C17.109 2.7505 21.25 6.8915 21.25 12.0005Z"
                stroke={stroke || "currentColor"}
                {..._strokeCommonProps}
            />
            <path
                d="M15.4311 14.9429L11.6611 12.6939V7.84691"
                stroke={stroke || "currentColor"}
                {..._strokeCommonProps}
            />
        </svg>
    );
};
